module.exports = __webpack_public_path__ + "static/media/law.07a5f13d.svg";